import { NgModule, InjectionToken } from '@angular/core';

/**
 * Variable para el InjectionToken de configuración de la aplicación.
 */
export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');


/**
 * Classe que define la configuración de la aplicación.
 *
 * @export
 * @class AppConfig
 */
export class AppConfig {

  /**
   * URL del back-end.
   *
   * @type {string}
   * @memberof AppConfig
   */
  backendURL: string;
  urlWithoutProtocol:string;

  /**
   * Path de la API.
   *
   * @type {string}
   * @memberof AppConfig
   */
  apiPath: string;

  /**
   * Mascara de fecha.
   *
   * @type {string}
   * @memberof AppConfig
   */
  dateMask: string;

  /**
   * Hora de inicio de las fichadas.
   *
   * En caso que la lista de fichadas de un dia esté vacia.
   *
   * @type {string}
   * @memberof AppConfig
   */
  startHour: string;

  /**
   * Protocolo de conexión.
   *
   * @type {string}
   * @memberof AppConfig
   */
  protocol: string;

  /**
   * Subdominio de cliente.
   *
   * @type {string}
   * @memberof AppConfig
   */
  client: string;

  /**
   * Activa els loadings en cada petición.
   *
   * @type {string}
   * @memberof AppConfig
   */
  showLoadings: boolean;
}

/**
 * Valores de la configuración.
 *
 */
export const APP_DI_CONFIG: AppConfig = {
    backendURL: 'https://x.softneos.com',
    urlWithoutProtocol: 'x.softneos.com',
    //backendURL: 'https://localhost:8889',
    //urlWithoutProtocol: 'localhost:8889',
    apiPath: 'api',
    protocol: 'https',
    //protocol: 'http',
    //client: 'x',
    client: '',
    dateMask: 'YYYY-MM-DD HH:mm:ss',
    startHour: '08:00',
    showLoadings: false
};

/**
 * Modulo de configuración de la aplicación.
 *
 * @export
 * @class AppConfigModule
 */
@NgModule({
  providers: [{
    provide: APP_CONFIG,
    useValue: APP_DI_CONFIG
  }]
})
export class AppConfigModule { }



// WEBPACK FOOTER //
// ./src/app/app-config.module.ts